import React from 'react';

import { Title } from 'components/Misc/Typography';
import { Button, Input, Datepicker } from 'components/Misc/Form';
import { Element, Handle } from 'components/Misc/Sortable';

import { useUserCreateStore } from 'store/user/useUserCreateStore';
import Show from 'components/Show';

const Course = ({ idx, gradeId, course }) => {
	// Use user's creation store
	const [onChangeStudentCourse, onRemoveStudentCourse, onChangeStudentExam] = useUserCreateStore(state => [
		state.onChangeStudentCourse,
		state.onRemoveStudentCourse,
		state.onChangeStudentExam
	]);

	// Handle course change for student
	const onChange = (change) => onChangeStudentCourse(gradeId, course.id, change);

	// Handle course removal for student
	const onRemove = () => onRemoveStudentCourse(gradeId, course.id);

	// Handle exam change for student
	const onExam = (change) => onChangeStudentExam(gradeId, course.id, change);

	return (
		<Element index={idx} className="py-2 px-3 flex items-center space-x-2 bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg transition-colors">
			{/* Drag handle */}
			<Handle />
			
			<div className="flex-1 space-y-2">
				{/* Course's information and control */}
				<div className="flex-1 flex items-center space-x-2">
					<Title
						title={course.title}
						subtitle={course.subject?.title}
						className="flex-1"
					/>

					<Button
						small
						square
						icon="link"
						to={`/courses/${course.id}`}
					/>

					<Button
						small
						square
						icon="close"
						theme="danger"
						onClick={onRemove}
					/>
				</div>

				{/* Course's dates */}
				<div className="flex space-x-2">
					<Datepicker
						name="startDate"
						label="Sākuma datums"
						value={course.startDate}
						onChange={onChange}
					/>

					<Datepicker
						end
						name="endDate"
						label="Beigu datums"
						value={course.endDate}
						onChange={onChange}
					/>
				</div>

				{/* Course's exam */}
				<Show if={course?.exam?.id}>
					<div className="flex items-center space-x-2">
						<Title
							title={course.exam?.title}
							subtitle="Ieskaite"
							className="flex-1 text-sm"
						/>

						<Input
							name="mark"
							value={course.exam?.mark}
							onChange={onExam}
							className="w-9"
							inputClassName="px-1 text-center"
						/>
					</div>
				</Show>
			</div>
		</Element>
	);
};

export default Course;